<template>
  <div class="hello">
    <h1>main</h1> 
    <el-button id="sss" @click="onclick" type="success">Success</el-button> 
    <el-button id="sss" @click="sky" type="success">请求</el-button> 
  
    <router-view />
  </div>
</template>

<script> 
import { ref, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted } from 'vue';
import routers from '@/router'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
    onclick: function () { 
      alert(1);
    },
    sky: function () { 
      this.$router.push({ path: '/post', query: { active: 1 } });
    },
  },
  setup() {
    const name = ref('1111111111Vue 3');

    onBeforeMount(() => {
      console.log('1111111111beforeMount');
    });

    onMounted(() => {
      console.log('1111111111mounted');
    });

    onBeforeUpdate(() => {
      console.log('1111111111beforeUpdate');
    });

    onUpdated(() => {
      console.log('1111111111updated');
    });

    onBeforeUnmount(() => {
      console.log('1111111111beforeUnmount');
    });

    onUnmounted(() => {
      console.log('1111111111unmounted');
    });

    return {
      name,
    };
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
